import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCurrentUser } from '../localStorage';
var Auth = function (_a) {
    var role = _a.role, children = _a.children;
    var navigate = useNavigate();
    var location = useLocation();
    React.useEffect(function () {
        var currentUser = getCurrentUser();
        if (!currentUser.id || currentUser.role !== role) {
            navigate("/".concat(role, "/login"), {
                replace: true,
                state: { redirectTo: "".concat(location.pathname).concat(location.search) },
            });
            return;
        }
        else if (role === 'producer' && !currentUser.producer) {
            navigate('/producer/edit', { replace: true });
        }
        else if (role === 'roaster' &&
            (!currentUser.roaster || currentUser.roaster.needEditProfile)) {
            navigate('/roaster/edit', { replace: true });
            if (TYPICA_GTM_CONVERSION_SEND_TO) {
                gtag('event', 'conversion', {
                    send_to: TYPICA_GTM_CONVERSION_SEND_TO,
                });
            }
        }
    }, [role, navigate, location.pathname, location.search]);
    return React.createElement(React.Fragment, null, children);
};
export default Auth;
